export default [
    {
        path: '/calculators/keyplan',
        component: require('./../../functional/Index').default,
        meta: {},
        children: [
            {
                path: '',
                name: 'KeyPlan™ Calculator',
                component: require('./../../views/Calculators/KeyPlan/Index').default
            }
        ]
    },
]
